import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import FormAdvancedOptions from "./FormAdvancedOptions";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError] = useState(null);
  const { pollingInterval } = formData;
  const handleSubmit = () => {
    onSubmit();
  };
  return /* @__PURE__ */ React.createElement(FormWrap, { onSubmit: handleSubmit, buttonContent: "Proceed", title: "", error: formError, description: "" }, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pollingInterval",
      type: "number",
      value: pollingInterval.value || pollingInterval.defaultValue,
      min: "1",
      max: "60",
      onChange,
      required: true,
      help: "Determines how often (in minutes) the input will check for new data from Google Workspace. The smallest allowable interval is 5 minutes.",
      label: "Polling Interval"
    }
  ), /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange }));
};
export default StepSubscribe;
